(() => {
  if (window.peCollectionReady) return;
  window.peCollectionReady = true;

  const setupClubSlider = (scope = document) => {
    scope.querySelectorAll('[data-pe-club-track]').forEach((track) => {
      if (track.dataset.ready === 'true') return;
      track.dataset.ready = 'true';
      const wrapper = track.closest('.pe-club-picker');
      const distance = () => (track.querySelector('.pe-club-card')?.getBoundingClientRect().width || 180) + 12;
      wrapper?.querySelector('[data-pe-club-previous]')?.addEventListener('click', () => track.scrollBy({ left: -distance(), behavior: 'smooth' }));
      wrapper?.querySelector('[data-pe-club-next]')?.addEventListener('click', () => track.scrollBy({ left: distance(), behavior: 'smooth' }));
    });
  };

  const loadMore = async (button) => {
    if (!button || button.dataset.loading === 'true' || !button.dataset.nextUrl) return;
    const container = button.closest('[data-pe-infinite]');
    const status = container.querySelector('[data-pe-infinite-status]');
    const count = container.querySelector('[data-pe-infinite-count]');
    button.dataset.loading = 'true';
      container.classList.add('is-loading');
      button.disabled = true;
      try {
        const response = await fetch(button.dataset.nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Could not load products');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingGrid = html.querySelector('#product-grid');
        const currentGrid = document.querySelector('#product-grid');
        incomingGrid?.querySelectorAll(':scope > li').forEach((item) => currentGrid?.appendChild(item));

        const incomingButton = html.querySelector('[data-pe-load-more]');
        const incomingCount = html.querySelector('[data-pe-infinite-count]');
        if (incomingCount && count) count.textContent = incomingCount.textContent;
        if (incomingButton?.dataset.nextUrl) {
          button.dataset.nextUrl = incomingButton.dataset.nextUrl;
          button.disabled = false;
        } else {
          button.remove();
          if (status) status.textContent = status.dataset.completeLabel || 'All products loaded';
        }
      } catch (error) {
        button.disabled = false;
        if (status) status.textContent = 'Could not load more products. Please try again.';
      } finally {
        button.dataset.loading = 'false';
        container.classList.remove('is-loading');
      }
  };

  const maybeLoadMore = () => {
    const button = document.querySelector('[data-pe-load-more]');
    if (button && button.getBoundingClientRect().top <= window.innerHeight + 500) loadMore(button);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pe-load-more]');
    if (!button) return;
    event.preventDefault();
    loadMore(button);
  });

  let ticking = false;
  document.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      maybeLoadMore();
    });
  }, { passive: true });

  const setup = () => {
    setupClubSlider();
    maybeLoadMore();
  };
  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:reorder', setup);
})();
